import { render } from "./DetailsandattachmentsTabContent.vue?vue&type=template&id=ef57f240"
import script from "./DetailsandattachmentsTabContent.vue?vue&type=script&lang=js"
export * from "./DetailsandattachmentsTabContent.vue?vue&type=script&lang=js"

import exportComponent from "E:\\my project backsups\\vue\\vuestyle3\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__